import { useDispatch, useSelector } from 'react-redux';
import { Content, FlexboxGrid } from 'rsuite';
import {
  PAYMENT_PROVIDER,
  PAYMENT_METHODS,
} from '../../components/payment/constants';
import PortalHeader from '../../components/layout/PortalHeader';
import FlowPageLayout from '../../components/layout/FlowPageLayout';
import { FLOWS_ENUM } from '../../common/enums';
import {
  selectPaymentID,
  selectSelectedPaymentMethod,
} from '../../store/slices/payment/paymentSelectors';
import React, { useCallback, useMemo } from 'react';
import { checkTaxPaymentAsync } from '../../store/slices/payment/paymentThunk';
import { selectConfigSettings } from '../../store/slices/config/configSelectors';
import usePlaceNavigate from '../../hooks/usePlaceNavigate';
import Payment from '../../components/payment/common/GenericPayment/Payment';

const TaxPayment = () => {
  const dispatch = useDispatch();
  const placeNavigate = usePlaceNavigate();

  const paymentID = useSelector(selectPaymentID);
  const settings = useSelector(selectConfigSettings);
  const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);
  const provider = settings.paymentProcessor;

  const redirectUrl = useMemo(() => {
    if (selectedPaymentMethod === PAYMENT_METHODS.CHECK) {
      return '/tax-success';
    }
    switch (provider) {
      case PAYMENT_PROVIDER.GENERIC:
      case PAYMENT_PROVIDER.XPRESS_BILL_PAY:
        return '/payment-redirect';
      case PAYMENT_PROVIDER.Stripe:
      default:
        return '/tax-success';
    }
  }, [provider, selectedPaymentMethod]);

  const onSuccess = useCallback(
    (omitCheck) => {
      if (!omitCheck) {
        dispatch(checkTaxPaymentAsync(paymentID, placeNavigate(redirectUrl)));
      } else {
        placeNavigate(redirectUrl);
      }
    },
    [paymentID, placeNavigate, dispatch, redirectUrl]
  );

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader title="Pay Tax" />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content>
          <FlowPageLayout
            flow={FLOWS_ENUM.PAY_TOT}
            hideNextButton={true}
          >
            <Payment
              flow={FLOWS_ENUM.PAY_TOT}
              onSuccess={onSuccess}
              permitIdentifier={undefined}
              singlePaymentButton={
                provider === PAYMENT_PROVIDER.GENERIC ||
                provider === PAYMENT_PROVIDER.XPRESS_BILL_PAY
              }
            />
          </FlowPageLayout>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default TaxPayment;
